import { useEffect, useMemo, useState, type RefObject } from 'react'
import { DEFAULT_ROW_HEIGHT } from '../Gantt.utils'

type UseGanttBodyFillerArgs = {
  bodyScrollRef: RefObject<HTMLDivElement | null>
  totalBodyHeight: number
}

const useGanttBodyFiller = ({
  bodyScrollRef,
  totalBodyHeight
}: UseGanttBodyFillerArgs) => {
  const [bodyViewportHeight, setBodyViewportHeight] = useState(0)

  useEffect(() => {
    const bodyNode = bodyScrollRef.current
    if (!bodyNode) return

    const observer = new ResizeObserver(() => {
      setBodyViewportHeight(bodyNode.clientHeight)
    })
    observer.observe(bodyNode)
    setBodyViewportHeight(bodyNode.clientHeight)

    return () => observer.disconnect()
  }, [bodyScrollRef])

  const { fillerRowHeights, timelineCanvasHeight } = useMemo(() => {
    const extraBodyHeight = Math.max(0, bodyViewportHeight - totalBodyHeight)
    const fillerRowCount = Math.ceil(extraBodyHeight / DEFAULT_ROW_HEIGHT)
    const fillerRowHeights =
      extraBodyHeight > 0
        ? Array.from({ length: fillerRowCount }, (_unused, index) =>
            index === fillerRowCount - 1
              ? extraBodyHeight - DEFAULT_ROW_HEIGHT * (fillerRowCount - 1)
              : DEFAULT_ROW_HEIGHT
          )
        : []
    const timelineCanvasHeight = totalBodyHeight + extraBodyHeight

    return { fillerRowHeights, timelineCanvasHeight }
  }, [bodyViewportHeight, totalBodyHeight])

  return { fillerRowHeights, timelineCanvasHeight }
}

export default useGanttBodyFiller
